import { useState, useCallback, createContext, useContext } from 'react';

const NotificationModalContext = createContext(undefined);

export const NotificationModalProvider = ({ children }) => {
  const [notificationModal, setNotificationModal] = useState({
    isOpen: false,
    title: '',
    message: '',
    type: 'info',
  });

  const showNotificationModal = useCallback((title, message, type = 'info') => {
    setNotificationModal({
      isOpen: true,
      title,
      content: typeof message !== 'string' ? message : null,
      message: typeof message === 'string' ? message : null,
      type,
    });
  }, []);

  const hideNotificationModal = useCallback(() => {
    setNotificationModal((prev) => ({ ...prev, isOpen: false }));
  }, []);

  return (
    <NotificationModalContext.Provider
      value={{
        notificationModal,
        showNotificationModal,
        hideNotificationModal,
      }}
    >
      {children}
    </NotificationModalContext.Provider>
  );
};

export const useNotificationModal = () => {
  const context = useContext(NotificationModalContext);

  if (!context)
    throw new Error(
      'useNotificationModal must be used within NotificationModalProvider'
    );

  return context;
};
